<template>
  <div class="c-select">
    <div
      class="c-select-input c:row-between-center"
      :class="{
        disabled: computedDisabled,
        'placeholder-mode': value === undefined || !options[value],
        large,
      }"
      @click="throttledOnPickerClick"
    >
      <span>{{
        value !== undefined && options[value]
          ? options[value].label
          : placeholder || title
      }}</span>
      <img src="@/assets/icons/drop-down.svg" class="arrow-down" alt="" />
    </div>
    <CBottomPopup v-model="visible" :title="title" :max-height="maxHeight">
      <div class="c-select-list">
        <div
          v-for="(item, idx) in options"
          :key="keyProp ? item[keyProp] : idx"
          class="c-select-item c:row-between-center"
          :class="{ active: value === idx }"
          @click="throttledOnOptionClick(idx)"
        >
          <span>{{ item.label }}</span>
          <div class="c-select-item-radio">
            <img
              class="checked-icon"
              src="../../assets/icons/checked.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </CBottomPopup>
  </div>
</template>
<script>
import { throttle } from "@/utils";
import CBottomPopup from "./CBottomPopup.vue";
export default {
  components: {
    CBottomPopup,
  },
  props: {
    title: {
      type: String,
      default: "请选择",
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: undefined,
    },
    disabled: Boolean,
    placeholder: String,
    keyProp: {
      type: String,
      default: undefined,
    },
    maxHeight: {
      type: [Number, String],
      default: "50vh",
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    computedDisabled() {
      return this.disabled || !this.options?.length;
    },
  },
  created() {
    this.throttledOnPickerClick = throttle(this.onPicker, 500);
    this.throttledOnOptionClick = throttle(this.select, 500);
  },
  methods: {
    onPicker() {
      if (this.computedDisabled) return;
      this.visible = true;
    },
    select(index) {
      this.visible = false;
      this.$emit("input", index);
      this.$emit("change", index, this.options[index]);
    },
  },
};
</script>
<style lang="less" scoped>
.c-select {
  .c-select-input {
    height: 40/20rem;
    border: 1/20rem solid #c7c9cc;
    padding: 0 12/20rem 0 10/20rem;
    background-color: #fff;

    font-size: 12/20rem;
    color: #000000;

    &.disabled {
      opacity: 0.4;
    }

    &.placeholder-mode {
      color: #666666;
    }

    &.large {
      height: 46/20rem;
      border: 1/20rem solid #979797;
      font-size: 14/20rem;
    }
    &.large.placeholder-mode {
      color: #909090;
    }
    .arrow-down {
      width: 22/20rem;
      height: 22/20rem;
    }
  }
  .c-select-list {
    box-sizing: border-box;
    padding: 0 16/20rem 30/20rem;
    .c-select-item {
      height: 56/20rem;
      border-top: 1/20rem solid #e4e4e4;
      font-size: 14/20rem;
      font-weight: 400;
      color: #000;
      &:last-child {
        border-bottom: 1/20rem solid #e4e4e4;
      }
      .c-select-item-radio {
        border: 2/20rem solid #dcdddf;
        width: 22/20rem;
        height: 22/20rem;
        border-radius: 50%;

        .checked-icon {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          display: none;
        }
      }
      &.active {
        font-weight: 600;
        .c-select-item-radio {
          border-color: #000;
          .checked-icon {
            display: block;
          }
        }
      }
    }
  }
}
</style>
